import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillPhone,
  AiFillMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm <b className="purple">Naveen Kumar M</b>, a passionate Java Developer with
              <b className="purple"> 3 years 8 months </b> of experience in building
              scalable web applications.
              <br />
              <br />
              Proficient in:
              <i>
                <b className="purple"> Java, Spring Boot, Microservices, Hibernate, React, PHP, JavaScript</b>
              </i>
              <br />
              <br />
              Experienced in crafting
              <i>
                <b className="purple"> RESTful APIs</b>
              </i>, system design for distributed systems, and integrating solutions with
              <i>
                <b className="purple"> Docker, Keycloak, Redis, Typesense, and more</b>
              </i>.
              <br />
              <br />
              Passionate about
              <b className="purple"> exploring emerging technologies </b> and staying updated with the
              <b className="purple"> latest in Cybersecurity</b>, utilizing tools like
              <i>
                <b className="purple"> Metasploit Framework</b>
              </i> and Linux-based platforms.
              <br />
              <br />
              <b className="purple">Current Role:</b> Java Spring Boot Developer at Impiger Technologies.
              <br />
              Working on large-scale projects such as:
              <ul>
                <li>
                  <b className="purple">Recruitment Management Platform</b> for Xpheno — involving
                  real-time communication, smart notification engines, and
                  Typesense search.
                </li>
                <li>
                  <b className="purple">Supplier Management System</b> for Rane — built with PHP,
                  Laravel, and JavaScript for supplier data consolidation.
                </li>
              </ul>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/kiranaveen"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="tel:+916383322923"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillPhone />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/naveen-kumar-9986b42a4"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:naveenkumar735854@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
